module.exports = __webpack_public_path__ + "img/tdxz.22817bf9.png";